import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { trackPageImpression, trackPageView } from '../../utils/useOneTag';
import { useFeatureFlags } from '../../utils/useFeatureFlags';

const TrackedRoute = (props) => {
  const { market } = useSelector((state) => state.markets);
  const { refreshSearchRevampFlagIsEnabled } = useFeatureFlags();

  useEffect(() => {
    if (
      window.location.pathname === '/search' &&
      refreshSearchRevampFlagIsEnabled
    ) {
      trackPageView(window.location.pathname + '-refresh');
    } else {
      trackPageView(window.location.pathname);
    }
    trackPageImpression('user-market', 'user-market', market?.id);
  }, [market, refreshSearchRevampFlagIsEnabled]);
  return <Route {...props} />;
};

export default TrackedRoute;
